// material-ui

import boxedtruck12ton2axles from '../../../assets/images/Truck/boxed-truck-12-ton-2-axles.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const BoxedTruck12Ton2Axles = (props) => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={boxedtruck12ton2axles} alt="Boxed truck 12 ton, 2 axles " height={props.height || 25} style={{verticalAlign:'top'}}  />
    );
};

export default BoxedTruck12Ton2Axles;